import {Skeleton} from 'antd';
import {ReactNode, useCallback, useEffect, useState} from 'react';
import InfiniteScrollComponent from 'react-infinite-scroll-component';
import Loading from './Loading';

type Props = {
  pageLimit: number;
  loading: boolean;
  data?: any[];
  children: (data?: any[]) => ReactNode;
  onLoadMore: (options: any) => Promise<any[]>;
};
export default function InfiniteScroll(props: Props) {
  const [hasMore, setHasMore] = useState<boolean>(true);

  useEffect(() => {
    if (props.data && props.data.length < props.pageLimit) {
      setHasMore(false);
    }
  }, [props.data, props.pageLimit]);

  const handleLoadMore = useCallback(async () => {
    const data = await props.onLoadMore({variables: {skip: props.data?.length}});
    if (!data || data.length < props.pageLimit) {
      setHasMore(false);
    }
  }, [props]);

  return (
    <Skeleton loading={props.loading} active={props.loading}>
      <InfiniteScrollComponent
        dataLength={props.data?.length || 0}
        next={handleLoadMore}
        hasMore={hasMore}
        loader={<Loading />}
        endMessage={
          <p style={{textAlign: 'center', fontSize: 18}}>
            <b>You've reached the end, here have a 🍪</b>
          </p>
        }>
        {props.children(props.data)}
      </InfiniteScrollComponent>
    </Skeleton>
  );
}
